import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {
  GoBackView,
  GoBackViewProps,
} from '../../../features/GoBackView/GoBackView';
import {useLinksSection} from '../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';

export const GoBackMinimal: React.FC<
  GoBackViewProps & {productId: number}
> = props => {
  return (
    <DataFetcher
      request={useLinksSection(props.productId)}
      Error={() => null}
      Loading={() => null}
      View={GoBackView}
      viewProps={props}
    />
  );
};
